/**
 * Utility function to handle and log errors.
 * @param error - The original error object.
 * @param errorMessage - Custom error message to log.
 * @param overrides - Optional overrides for status, message, and params.
 */
export const handleMrtSsrErrors = (
    error: any,
    errorMessage: string,
    overrides: {status?: number; message?: string; params?: any} = {}
): never => {
    const status = overrides?.status || error?.response?.status || 500
    const message =
        overrides?.message ||
        error?.response?.data?.message ||
        error?.message ||
        'Internal Server Error'
    const params = overrides?.params || error.config?.params || error?.params || null

    const errorResponse = {
        errorMessage,
        message,
        params,
        status
    }

    console.error(errorResponse)
    throw errorResponse
}
